import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import './HostGameCode.css';

interface Props {
  gameId: string;
  /** QR image as a base64 data URL, fetched once by the parent. */
  qrCode?: string;
}

/**
 * Compact game-code + QR badge shown at the top-left of host game screens.
 * Smaller than the lobby's code card — meant to stay visible without
 * dominating the screen during play. Presentational: the QR is fetched once
 * by the parent and passed in, so switching screens never refetches.
 */
const HostGameCode: React.FC<Props> = ({ gameId, qrCode }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const baseUrl =
      process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    const url = `${baseUrl}/join?gameId=${gameId}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!gameId) return null;

  return (
    <div className="host-code">
      {qrCode && (
        <img
          className="host-code__qr"
          src={qrCode}
          alt="Scan to join game"
        />
      )}
      <div className="host-code__info">
        <span className="host-code__label">Game Code</span>
        <button
          className="host-code__value"
          onClick={handleCopy}
          title="Copy join link"
        >
          <span className="host-code__id">{gameId}</span>
          <FontAwesomeIcon icon={faCopy} className="host-code__copy-icon" />
        </button>
        {copied && <span className="host-code__copied">Copied!</span>}
      </div>
    </div>
  );
};

export default HostGameCode;
